import { INCOME_MEASUREMENT_TYPES } from '../constants/constants';

// Filter income measurement types based on customer state
// Types with no `states` property are available in all states
export const availableIncomeMeasurementTypes = (state) => {
  return INCOME_MEASUREMENT_TYPES.filter((type) => !type.states || type.states.includes(state)
)};

// Filter income measurement types based on customer state
// Types with no `states` property are available in all states
export const incomeMeasurementTypeProps = (state) => {
  return INCOME_MEASUREMENT_TYPES.filter((type) => !type.states || type.states.includes(state)
)};